export const FETCH_LOCATION_TYPE = {
  START: 'START_FETCH_LOCATION_TYPE',
  COMPLETE: 'COMPLETE_FETCH_LOCATION_TYPE',
  FAIL: 'FAIL_FETCH_LOCATION_TYPE',
  CLEANUP: 'CLEANUP_FETCH_LOCATION_TYPE',
}

export const UPDATE_LOCATION_TYPE_SIMPLE_DETAILS = {
  START: 'START_UPDATE_LOCATION_TYPE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_LOCATION_TYPE_DETAILS',
  FAIL: 'FAIL_UPDATE_LOCATION_TYPE_DETAILS',
}

export const UPDATE_LOCATION_TYPE_IMAGE_DETAILS = {
  START: 'START_UPDATE_LOCATION_TYPE_IMAGE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_LOCATION_TYPE_IMAGE_DETAILS',
  FAIL: 'FAIL_UPDATE_LOCATION_TYPE_IMAGE_DETAILS',
}
